<template>
  <div>
    <div
      class="feedback-tab"
      @click="openForm"
      v-if="!showForm"
      aria-label="Open feedback form"
    >
      <i class="mdi mdi-message-text-outline"></i>
      Feedback
    </div>
    <transition name="fade">
      <div v-if="showForm" class="feedback-form-container">
        <div class="feedback-form-header">
          <span>Send Feedback</span>
          <button class="close-btn" @click="closeForm" aria-label="Close feedback form">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
        <!-- <b-field label="Area">
          <b-select v-model="area" placeholder="Select area">
            <option value="General">General</option>
            <option value="Profile">Profile</option>
            <option value="Verification">Verification</option>
            <option value="Career Pathways">Career Pathways</option>
            <option value="Other">Other</option>
          </b-select>
        </b-field>
        <b-field label="Your Feedback">
          <b-input
            v-model="feedback"
            type="textarea"
            placeholder="Let us know what you think..."
            rows="4"
          ></b-input>
        </b-field>
        <div class="feedback-actions">
          <b-button
            type="is-primary"
            :disabled="!feedback || !area"
            :loading="loading"
            @click="submitFeedback"
          >
            Submit
          </b-button>
        </div>
        <p v-if="success" class="feedback-success">Thank you for your feedback!</p>
        <p v-if="error" class="feedback-error">{{ error }}</p> -->
        <HubSpotInternalFeedbackForm />
      </div>
    </transition>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import HubSpotInternalFeedbackForm from '@/components/HubSpotInternalFeedbackForm.vue';

export default {
  name: 'FeedbackLauncher',
  components: {
    HubSpotInternalFeedbackForm
  },
  data() {
    return {
      showForm: false,
      area: null,
      feedback: '',
      loading: false,
      success: false,
      error: ''
    };
  },
  created() {
    this.userStore = useUserStore()
  },
  methods: {
    openForm() {
      this.showForm = true;
      this.success = false;
      this.error = '';
      this.area = null;
      this.feedback = '';
    },
    closeForm() {
      this.showForm = false;
    },
    async submitFeedback() {
      this.loading = true;
      this.success = false;
      this.error = '';

      try {
        await this.axios.post(
          `${process.env.VUE_APP_API_URL}/feedback`,
          {
            area: this.area,
            message: this.feedback,
            user: this.userStore.user?._id,
          }
        );
        // console.log("Feedback submitted:", {
        //   area: this.area,
        //   message: this.feedback,
        //   user: {
        //     id: this.userStore.user?._id || 'Anonymous',
        //     firstName: this.userStore.user?.firstName || 'Anonymous',
        //     lastName: this.userStore.user?.lastName || '',
        //     email: this.userStore.user?.email || 'N/A'
        //   }
        // });


        this.success = true;
        this.feedback = '';
        setTimeout(() => {
          this.closeForm();
        }, 1500);
      } catch (err) {
        this.error = err?.response?.data?.message || 'Could not submit feedback. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback-tab {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  background: $color-primary;
  color: $color-surface;
  border-radius: $radius-pill;
  padding: 0.7rem 1.5rem;
  font-weight: 700;
  font-size: 1.08rem;
  box-shadow: $shadow-sm;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  z-index: 9999;
  transition: background 0.18s;
  i {
    font-size: 1.5rem;
  }
  &:hover, &:focus {
    background: $color-accent;
    color: $color-surface;
  }
}

.feedback-form-container {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  width: 320px;
  background: $color-surface;
  border-radius: $radius-lg;
  box-shadow: $shadow-lg;
  padding: 1.5rem 1.2rem 1.2rem 1.2rem;
  color: $color-text;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.feedback-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 1.15rem;
  color: $color-primary;
  margin-bottom: 0.5rem;
  .close-btn {
    background: none;
    border: none;
    color: $color-accent;
    font-size: 1.3rem;
    cursor: pointer;
    padding: 0;
    margin-left: 0.5rem;
  }
}

.feedback-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 0.5rem;
}

.feedback-success {
  color: $color-success-bright;
  font-weight: 600;
  margin-top: 0.7rem;
}

.feedback-error {
  color: $color-accent;
  font-weight: 600;
  margin-top: 0.7rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 600px) {
  .feedback-tab,
  .feedback-form-container {
    right: 0.3rem;
    bottom: 0.3rem;
    width: 95vw;
    max-width: 95vw;
  }
}
</style>
